export enum PROFILE_ROUTE_TITLES {
  Address = 'PROFILE.menu.address_book',
  Favorites = 'PROFILE.menu.favorites',
  GiftCards = 'PROFILE.menu.gift_cards',
  Orders = 'PROFILE.menu.orders',
  Password = 'PROFILE.menu.change_password',
  Payment = 'PROFILE.menu.payment_methods',
  Profile = 'PROFILE.menu.profile',
}
